var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-container container"},[_c('draggable',{attrs:{"options":{animation: 150, handle: '.ddHandle'}},model:{value:(_vm.cards),callback:function ($$v) {_vm.cards=$$v},expression:"cards"}},_vm._l((_vm.cards),function(card){return _c('card',{key:card.id,attrs:{"card":card}})}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78d6d4a1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CardContainer.vue
// module id = 1939
// module chunks = 1